module.exports = __webpack_public_path__ + "78eddc7351a1d8f0632540ea1b611875.jpg";